module.exports = __webpack_public_path__ + "static/media/bookhaven.1226b3be.jpg";